export enum routesList {
    ADMIN = '/admin',
    ADMIN_USERS = '/admin/users',
    ADMIN_USERS_NEW = '/admin/users/new',
    ADMIN_USERS_EDIT = '/admin/users/edit',
    ADMIN_AREAS = '/admin/areas',
    ADMIN_AREAS_EDIT = '/admin/areas/manage',
    ADMIN_POSITIONS = '/admin/positions',
    ADMIN_POSITIONS_NEW = '/admin/positions/new',
    ADMIN_POSITIONS_EDIT = '/admin/positions/edit',
    ADMIN_PROFILES = '/admin/profiles',
    ADMIN_INVITATION = '/admin/invitation',
    CIRCUITS = '/circuits',
    CIRCUITS_NEW = '/circuits/new',
    CIRCUITS_SENT = '/circuits/sent',
    CIRCUITS_DRAFT = '/circuits/draft',
    CIRCUITS_ORGANIZATION = '/circuits/organization',
    CIRCUITS_DETAIL = '/circuits/detail',
    CIRCUITS_CUSTOM = '/circuits/custom',
    CIRCUITS_CUSTOM_NEW = '/circuits/custom/new',
    CIRCUITS_CUSTOM_EDIT = '/circuits/custom/edit',
    CIRCUITS_MASSIVE_NEW = '/circuits/massive/new',
    TASKS = '/tasks',
    TASKS_PENDING = '/tasks/pending',
    TASKS_ORGANIZATION = '/tasks/organization',
    TASKS_REASSIGN = '/tasks/reassign',
    TASKS_DELEGATIONS = '/tasks/delegations',
    TASKS_DELEGATIONS_NEW = '/tasks/delegations/new',
    TASKS_DELEGATIONS_EDIT = '/tasks/delegationa/edit',
    VERIFICATION = '/u/verification',
    _MORE = 'MORE',
    _FAQ = 'FAQ',
    _MANUAL = 'MANUAL',
    COMPANY_RELATIONS = '/company-relations',
    COMPANY = '/company',
    PROFILE = '/profile',
    PANEL = '/panel',
    PANEL_USERS = '/panel/users',
    PANEL_PERSONALIZATIONS = '/panel/personalizations',
    PANEL_ORGANIZATIONS = '/panel/organizations',
    PANEL_CIRCUITS = '/panel/circuits',
    PANEL_SENT_CIRCUITS = '/panel/sent-circuits',
    PANEL_ADMIN_CIRCUITS = '/panel/admin-circuits-management',
    PANEL_MANAGE_CUSTOM = '/panel/manage',
    PANEL_CREDITS = '/panel/credits',
    PANEL_CUSTOM_CIRCUITS = '/panel/custom-circuits',
    PANEL_TEMPLATES = '/panel/templates',
    PANEL_ACCESS_MANAGEMENT = '/panel/access-management',
    PANEL_PREFIXES = '/panel/prefixes',
    PANEL_WIDGETS = '/panel/widgets',
    CONTACTS = '/contacts',
    PANEL_TERMS_AND_CONDITIONS = '/panel/terms-and-conditions',
    PANEL_SIGNATURE_TYPE = '/panel/signature-type',
    PANEL_COMPANY_CERTS = '/panel/certs',
    PANEL_SENDERS = '/panel/senders',
    PANEL_REPROCESS_CALLBACKS = '/panel/reprocess',
}
